<script setup lang="ts">
import Loading from '@/components/Loading.vue';
import Pagination from '@/components/Pagination.vue';
import Ratings from '@/components/Ratings.vue';
import Sort from '../Sort.vue';

import { date, euro } from '@/helpers';
import { computed, onMounted } from 'vue';
import { useFilters } from '..';

const { index, search, loading, getFeatured, featured } = useFilters();

onMounted(index);

const filtered = computed(() => search.value?.data?.filter(({ pricing }) => pricing.price) || []);
//const failed = computed(() => search.value?.data.every(({ pricing }) => typeof pricing === 'boolean' && pricing === false) || false);
const failed = computed(() => search.value?.data.every(({ pricing }) => !pricing || !pricing.price || !pricing.price.perperson) || false);
</script>

<template>
  <Loading v-model:loading="loading" :fallback="search?.data?.length === 0 || failed" @fallback="getFeatured">
    <template #fallback>
      <div class="loader__empty --margins">
        <div class="--inner">
          <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32" height="32">
              <path
                d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
              />
            </svg>
          </span>
          <h2 class="block__title">Geen resultaten gevonden</h2>
          <p class="block__text">
            Helaas is er op de door jou gekozen data geen beschikbaarheid voor de gewenste reis. We adviseren je om opnieuw te zoeken met
            een andere reisdatum of een aangepast aantal nachten. Of vraag vrijblijvend een offerte aan via de chat.
          </p>
        </div>
      </div>
      <template v-if="featured">
        <div class="container">
          <div class="row m-auto">
            <div class="block__content">
              <div class="block__header mb-3">
                <h3 class="block__title mb-0">Bekijk ook één van onderstaande reisopties</h3>
              </div>
            </div>
          </div>
          <div class="row">
            <template v-for="(item, index) in featured" :key="index">
              <div class="col-md-6">
                <a class="block block--package" :href="item.pricing.accommodationurl" :title="item.room.accommodation.name" tarindex="_top">
                  <p class="block__img__meta">{{ date.format(new Date(item.date)) }}, {{ item.persons }} personen</p>
                  <img defer v-if="item.room.accommodation.photos[0]" :src="item.room.accommodation.photos[0].url" class="block__img" />
                  <div class="block__content">
                    <div class="block__header">
                      <h3 class="block__title">{{ item.room.accommodation.name }}</h3>
                      <Ratings :rating="item.room.rating" />
                    </div>
                    <ul>
                      <template v-for="({ title }, index) in item.pricing.included" :key="index">
                        <li>{{ title }}</li>
                      </template>
                      <li>Gratis eigen ski’s mee op de vlucht</li>
                    </ul>
                  </div>
                  <div class="block__footer">
                    <div class="block__price">
                      <span class="block__price">
                        {{ euro.format(item.pricing.price.perperson.amount) }}
                      </span>
                      <span class="block__price"> p.p. </span>
                    </div>
                    <a class="button" title="" :href="item.pricing.accommodationurl">Bekijk</a>
                  </div>
                </a>
              </div>
            </template>
          </div>
        </div>
      </template>
    </template>
    <div class="container">
      <div class="block block--info margin">
        <p class="block__text">
          Er zijn <b>{{ search?.total }} resultaten</b> gevonden
        </p>
        <div class="block__sort">
          <p class="block__text">Sorteer op</p>
          <div class="label">
            <Sort></Sort>
          </div>
        </div>
      </div>
      <div class="row">
        <template v-for="(item, index) in filtered" :key="index">
          <div class="col-md-6">
            <a class="block block--package" :href="item.pricing.accommodationurl" :title="item.room.accommodation.name" tarindex="_top">
              <img defer v-if="item.room.accommodation.photos[0]" :src="item.room.accommodation.photos[0].url" class="block__img" />
              <div class="block__content">
                <div class="block__header">
                  <h3 class="block__title">{{ item.room.accommodation.name }}</h3>
                  <Ratings :rating="item.room.rating" />
                </div>
                <ul>
                  <template v-for="({ title }, index) in item.pricing.included" :key="index">
                    <li>{{ title }}</li>
                  </template>
                  <li>Gratis eigen ski’s mee op de vlucht</li>
                </ul>
              </div>
              <div class="block__footer">
                <div class="block__price">
                  <span class="block__price">
                    {{ euro.format(item.pricing.price.perperson.amount) }}
                  </span>
                  <span class="block__price"> p.p. </span>
                </div>
                <a class="button" title="" :href="item.pricing.accommodationurl">Bekijk</a>
              </div>
            </a>
          </div>
        </template>
      </div>
    </div>
    <Pagination
      :pagination="{
        current_page: search?.current_page,
        last_page: search?.last_page,
        next_page_url: search?.next_page_url,
        prev_page_url: search?.prev_page_url,
      }"
      @paginate="index"
    />
  </Loading>
</template>

<style scoped>
svg {
  width: 100px !important;
}
</style>
